'use client'

import Link from 'next/link'
import { LogIn } from 'lucide-react'
import { FglHeader } from '@/components/layout/fgl-header'
import { useTranslation } from '@/i18n/client'
import {
  LenisProvider,
  Reveal,
  Magnetic,
  LivingThermal,
  GliderBackdrop, GliderOrbit,
} from '@/components/award'

export default function LoginPage() {
  const { t } = useTranslation()

  return (
    <LenisProvider>
      <div data-award="true" className="relative min-h-screen flex flex-col" style={{ background: 'var(--award-ink)' }}>
        <FglHeader />
      <GliderBackdrop />

        <main className="relative flex-1 flex items-center justify-center overflow-hidden pt-[84px] pb-16">
          <div className="relative z-10 max-w-[900px] mx-auto px-6 md:px-12 text-center">
            <Reveal>
              <div className="flex items-center justify-center gap-3 mb-6 flex-wrap">
                <span className="award-eyebrow">Login · Modal-Trigger</span>
                <span className="h-px w-16 bg-[var(--award-line-hi)]" />
                <span className="award-label">2FA · TOTP · BLE-Login</span>
              </div>
            </Reveal>

            <Reveal delay={1}>
              <h1 className="award-h-mega">
                Willkommen <span className="award-grad-text">zurück.</span>
              </h1>
            </Reveal>

            <Reveal delay={2}>
              <p className="award-body-lead mx-auto mt-6 mb-10">
                {t('auth.loginPageHint')}
              </p>
            </Reveal>

            <Reveal delay={3}>
              <div className="flex gap-4 justify-center flex-wrap">
                <Magnetic>
                  <Link href="/?login=open" className="award-btn award-btn-primary">
                    <LogIn size={16} />
                    {t('auth.loginTitle')}
                  </Link>
                </Magnetic>
                <Magnetic>
                  <Link href="/register" className="award-btn award-btn-ghost">
                    Noch kein Konto?
                  </Link>
                </Magnetic>
              </div>
            </Reveal>
          </div>
        </main>
      </div>
    </LenisProvider>
  )
}
